import { Selector, State } from "./types";
import { matchRequest } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveCapacityRequestPending(
      from,
      to,
      granularity,
      filter,
      sort,
      size,
    ) {
      const state = getState();
      const index = matchRequest(
        state,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.request.isPending : false;
    },
    isRetrieveCapacityRequestSuccess(
      from,
      to,
      granularity,
      filter,
      sort,
      size,
    ) {
      const state = getState();
      const index = matchRequest(
        state,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.request.isSuccessful : false;
    },
    isRetrieveCapacityRequestFailure(
      from,
      to,
      granularity,
      filter,
      sort,
      size,
    ) {
      const state = getState();
      const index = matchRequest(
        state,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.request.isFailure : false;
    },
    getCapacityContent(from, to, granularity, filter, sort, size) {
      const state = getState();
      const index = matchRequest(
        state,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.content : [];
    },
    getCapacityCurrentPage(from, to, granularity, filter, sort, size) {
      const state = getState();
      const index = matchRequest(
        state,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.currentPage : 0;
    },
    canLoadMoreCapacity(from, to, granularity, filter, sort, size) {
      const state = getState();
      const index = matchRequest(
        state,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.canLoadMore : true;
    },
    getCapacityTotalElements(from, to, granularity, filter, sort, size) {
      const state = getState();
      const index = matchRequest(
        state,
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      );
      const req = index !== -1 ? state[index] : undefined;

      return req ? req.totalElements : 0;
    },
  };
}

export { createSelector };
